angular.module("vgresiduos").controller("PgrsListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "declaracoes/pgrs");
		};
	}
]);
